import { render, staticRenderFns } from "./Embroidery_v1.vue?vue&type=template&id=62e21640&scoped=true"
import script from "./Embroidery_v1.vue?vue&type=script&lang=js"
export * from "./Embroidery_v1.vue?vue&type=script&lang=js"
import style0 from "./Embroidery_v1.vue?vue&type=style&index=0&id=62e21640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e21640",
  null
  
)

export default component.exports